import React from 'react'

export default function FormTitleDiv({fontSize,color,fontWeight,marginTop,marginBottom,text}) {
  return (
    <div style={{fontSize,fontWeight,marginTop,marginBottom,color}}>{text}</div>
  )
}
